<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">首页</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      充值卡管理
      <small>管理商城的充值卡...</small>
    </h1>
    <!-- end page-header -->
    <panel title="充值卡列表" :noButton="true">
      <div slot="heading-btn">
        <button type="button" class="btn btn-theme btn-sm" @click="fn_add">
          <i class="fa fa-plus"></i> 添加充值卡
        </button>
        <button type="button" class="btn btn-theme btn-sm m-l-10" @click="fn_download">
          <i class="fa fa-download"></i> 导出充值卡
        </button>
      </div>

      <Row :gutter="5">
        <Col span="4">
          <Input v-model="filterCond.batchNumber" placeholder="批次"></Input>
        </Col>
        <Col span="5">
          <Input v-model="filterCond.rechargeCard" placeholder="卡号"></Input>
        </Col>
        <Col span="4">
          <Input v-model="filterCond.userName" placeholder="使用人员昵称"></Input>
        </Col>
        <Col span="3">
          <Select v-model="filterCond.isUsed" placeholder="是否使用">
            <Option :value="99">不限制</Option>
            <Option :value="0">未使用</Option>
            <Option :value="1">已使用</Option>
          </Select>
        </Col>
        <Col span="3">
          <Button type="primary" class="btn btn-theme" @click="fn_query">查询</Button>
        </Col>
        <Col span="3" v-if="downloadUrl.length>0">
          <a target="__blank" class="btn btn-theme" :href="logourl + downloadUrl">文件下载</a>
        </Col>
      </Row>

      <Table border size="small" :columns="columns" :data="data" class="m-t-10">
        <template slot-scope="{ row }" slot="isUsed">
          <span v-if="row.is_used == 1" style="color:green">
            <i class="fa fa-check"></i>已使用
          </span>
          <span v-else>未使用</span>
        </template>
        <template slot-scope="{ row }" slot="status">
          <strong v-if="row.status == 0">有效</strong>
          <strong v-else style="color:red">无效</strong>
        </template>
        <template slot-scope="{ row }" slot="amount">{{ row.amount / 100 }}元</template>
        <template slot-scope="{ row }" slot="effexpdate">{{ row.effdate }} => {{ row.expdate }}</template>

        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            v-if="row.is_used == 0"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit(row, index)"
          >卡管理</button>

          <Poptip
            v-if="row.is_used == 0"
            transfer
            confirm
            title="是否要删除此充值卡?"
            @on-ok="fn_remove(row, index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger btn-sm">删除</button>
          </Poptip>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>

    <Drawer title="生成卡管理" v-model="v_create_card" width="800" :mask-closable="true">
      <Form :model="formData" ref="formData" :rules="rules" :labelWidth="120">
        <FormItem label="批次" prop="batchnumber">
          <Input v-model="formData.batchnumber" :maxlength="50" />
        </FormItem>

        <FormItem label="金额[分]" prop="amount">
          <InputNumber style="width:100%" v-model="formData.amount" />
        </FormItem>

        <FormItem label="开始时间" prop="effdate">
          <DatePicker type="date" style="width:100%" v-model="formData.effdate" />
        </FormItem>
        <FormItem label="结束时间" prop="expdate">
          <DatePicker type="date" style="width:100%" v-model="formData.expdate" />
        </FormItem>

        <FormItem label="生成数量">
          <InputNumber style="width:100%" :max="100" v-model="formData.numlimit" />
        </FormItem>

        <FormItem label="状态" prop="status">
          <Select v-model="formData.status">
            <Option :value="-1">无效</Option>
            <Option :value="0">有效</Option>
          </Select>
        </FormItem>

        <FormItem label="备注" prop="remarks">
          <Input type="textarea" :maxlength="255" v-model="formData.remarks" />
        </FormItem>
      </Form>

      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="v_create_card = false">关闭</Button>
        <Button type="primary" @click="fn_create_card">保存</Button>
      </div>
    </Drawer>
    <Drawer title="修改管理" v-model="v_edit_card" width="800" :mask-closable="true">
      <Form :model="cardData" ref="cardData" :rules="editrules" :labelWidth="120">
        <FormItem label="批次" prop="batchnumber">
          <Input v-model="cardData.batchnumber" :maxlength="50" />
        </FormItem>
        <FormItem label="卡号" prop="cardnumber">
          <Input v-model="cardData.cardnumber" :maxlength="50" />
        </FormItem>

        <FormItem label="金额[分]" prop="amount">
          <InputNumber style="width:100%" v-model="cardData.amount" />
        </FormItem>

        <FormItem label="开始时间" prop="effdate">
          <DatePicker type="date" style="width:100%" v-model="cardData.effdate" />
        </FormItem>
        <FormItem label="结束时间" prop="expdate">
          <DatePicker type="date" style="width:100%" v-model="cardData.expdate" />
        </FormItem>

        <FormItem label="状态" prop="status">
          <Select v-model="cardData.status">
            <Option :value="-1">无效</Option>
            <Option :value="0">有效</Option>
          </Select>
        </FormItem>

        <FormItem label="备注" prop="remarks">
          <Input type="textarea" :maxlength="255" v-model="cardData.remarks" />
        </FormItem>
      </Form>

      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="v_create_card = false">关闭</Button>
        <Button type="primary" @click="fn_store_card">保存</Button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import {
  getRechargeList,
  createRechareCard,
  storeRechargeCard,
  removeRechargeCard,
  downloadRechargeCard,
} from '@/api/rechargecard'

import moment from 'moment'

import { getToken } from '@/libs/util'
import config from '@/config'

export default {
  data() {
    return {
      logourl: config.baseUrl.imageurl,
      filterCond: {
        page: 1,
        pageNum: 10,
        rechargeCard: '',
        batchNumber: '',
        userName: '',
        isUsed: 99,
      },
      columns: [
        {
          title: '#',
          key: 'id',
          width: 50,
        },
        {
          title: '批次',
          key: 'batchnumber',
          width: 150,
        },
        {
          title: '卡号',
          key: 'cardnumber',
          width: 250,
        },
        {
          title: '金额',
          slot: 'amount',
          width: 120,
        },
        {
          title: '是否使用',
          slot: 'isUsed',
          width: 100,
        },
        {
          title: '使用人',
          key: 'user_name',
          width: 150,
        },
        {
          title: '使用时间',
          key: 'used_time',
          width: 150,
        },
        {
          title: '充值有效期',
          slot: 'effexpdate',
          width: 180,
        },
        {
          title: '备注',
          key: 'remarks',
        },
        {
          title: '状态',
          slot: 'status',
          width: 90,
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'left',
          fixed: 'right',
        },
      ],
      data: [],

      totalRows: 0,
      pageNum: 10,
      currentPage: 1,

      formData: {
        id: 0,
        batchnumber: '',
        cardnumber: '',
        effdate: moment().format('YYYY-MM-DD'),
        expdate: moment().add(3650, 'days').format('YYYY-MM-DD'),
        amount: 100,
        remarks: '',
        numlimit: 0,
        status: 0,
        is_used: 0,
      },
      rules: {
        batchnumber: [
          {
            required: true,
            message: '批次',
            trigger: 'blur',
          },
        ],
        amount: [
          {
            type: 'number',
            required: true,
            message: '金额',
            trigger: 'blur',
          },
        ],
      },
      editrules: {
        batchnumber: [
          {
            required: true,
            message: '批次必填',
            trigger: 'blur',
          },
        ],
        amount: [
          {
            type: 'number',
            required: true,
            message: '金额必填',
            trigger: 'blur',
          },
        ],
        cardnumber: [
          {
            required: true,
            message: '卡号必填',
            trigger: 'blur',
          },
        ],
      },
      cardData: {},
      v_create_card: false,
      v_edit_card: false,
      downloadUrl: '',
    }
  },
  mounted() {
    this.filterCond = {
      page: 1,
      pageNum: this.pageNum,
    }
    this.fn_load_data(this.filterCond)
  },

  methods: {
    fn_query() {
      this.filterCond.page = 1
      this.fn_load_data(this.filterCond)
    },
    fn_download() {
      //导出生成的充值卡
      downloadRechargeCard(this.filterCond)
        .then((res) => {
          if (res.data.code == 200) {
            this.downloadUrl = res.data.filename
            this.$Notice.success({
              title: '成功',
              desc: res.data.message,
            })
          } else {
            this.downloadUrl = ''
          }
        })
        .catch((error) => {
          this.$Notice.error({
            title: '失败',
            desc: error,
          })
        })
    },
    fn_add() {
      this.v_create_card = true
      this.formData = {
        id: 0,
        batchnumber: '',
        cardnumber: '',
        effdate: moment().format('YYYY-MM-DD'),
        expdate: moment().add(3650, 'days').format('YYYY-MM-DD'),
        amount: 100,
        remarks: '',
        numlimit: 1,
        status: 0,
        is_used: 0,
      }
    },
    fn_load_data(filterCond) {
      getRechargeList(filterCond).then((res) => {
        this.data = res.data.data
        this.totalRows = res.data.total
      })
    },
    fn_switchPage(page) {
      this.currentPage = page
      let filterCond = {
        page: page,
        pageNum: this.pageNum,
      }
      this.fn_load_data(filterCond)
    },
    fn_edit(row, index) {
      this.cardData = row
      this.v_edit_card = true
    },
    fn_store_card() {
      this.cardData.effdate = moment(this.cardData.effdate).format('YYYY-MM-DD')
      this.cardData.expdate = moment(this.cardData.expdate).format('YYYY-MM-DD')
      this.$refs.cardData.validate((valid) => {
        if (valid) {
          storeRechargeCard(this.cardData)
            .then((res) => {
              if (res.data.code == 200) {
                this.fn_query()
                this.v_edit_card = false
                this.$Notice.success({
                  title: '成功',
                  desc: res.data.message,
                })
              } else {
                this.$Notice.error({
                  title: '失败',
                  desc: res.data.message,
                })
              }
            })
            .catch((error) => {
              this.$Message.error(error)
            })
        }
      })
    },
    fn_create_card() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          createRechareCard(this.formData)
            .then((res) => {
              if (res.data.code == 200) {
                this.fn_query()
                this.v_create_card = false
                this.$Notice.success({
                  title: '成功',
                  desc: res.data.message,
                })
              } else {
                this.$Notice.error({
                  title: '失败',
                  desc: res.data.message,
                })
              }
            })
            .catch((error) => {
              this.$Message.error(error)
            })
        }
      })
    },
    fn_remove(row, index) {
      removeRechargeCard(row.id)
        .then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            this.data.splice(index, 1)
            this.$Notice.success({
              title: '成功',
              desc: res.data.message,
            })
          } else {
            this.$Notice.error({
              title: '失败',
              desc: res.data.message,
            })
          }
        })
        .catch((error) => {
          this.$Message.error(error)
        })
    },
  },
}
</script>
